<template>
  <div>
    <div class="main">
      <h2>商品庫</h2>
      <div class="search">
        <div class="fl">
          <a href="javascript:;">全部({{total}})</a>|
        </div>
        <div class="fr">
          <input type="text" placeholder="キーワード" v-model="val" />
          <a href="javascript:;">検索</a>
        </div>
      </div>
      <div class="content">
        <p>
          <span>
            <img src="../../../assets/img/exc-import.png" alt /> Excel導入
          </span>
          <span>
            <img src="../../../assets/img/exc-export.png" alt /> Excel導出
          </span>
        </p>
        <div class="all">
          <div class="checked fl">
            <input type="checkbox" v-model="checked" @change="allChecked" />
            <strong>すべてを選択</strong>
            <span @click="deleteCommodity">削除</span>
          </div>
          <div class="caozuo fr">
            <a href="javascript:;" class="zhuijia a">
              追加
              <i class="el-icon-caret-bottom"></i>
              <div class="superaddition">
                <ul>
                  <li>
                    <a href="javascript:;" @click="addDialogVisible = true">手動追加</a>
                    <!-- <router-link :to="{name:'proceedOrder',query:{state:1}}" target="_blank">手動追加</router-link> -->
                  </li>
                  <li>
                    <router-link :to="{name:'proceedOrder',query:{state:1}}" target="_blank">注文履歴</router-link>
                  </li>
                </ul>
              </div>
            </a>
            <a href="javascript:;" @click="zhuwen" class="a">注文</a>
          </div>
        </div>
        <div class="containet">
          <ol>
            <li>番号</li>
            <li>選択</li>
            <li>管理番号</li>
            <li>写真</li>
            <li>サイズ</li>
            <li>カラー</li>
            <li>単価</li>
            <li class="options">オプション</li>
            <li>FBA</li>
            <li>備考欄</li>
          </ol>
          <ul v-for="(item,index) in lists" :key="index" class="ul">
            <li>{{index +1}}</li>
            <li class="checkbox">
              <input type="checkbox" v-model="item.checked" @change="checkedItem" />
            </li>
            <li class="input">
              <input type="text" v-model="item.manageId" @blur="update(item,'manageId')" />
            </li>
            <li>
              <div class="img">
                <img :src="item.pic" alt />
                <div class="yinying"></div>
                <div class="upload el-icon-upload" @click="edit(item)"></div>
                <div class="img-box">
                  <img :src="item.pic" alt />
                </div>
              </div>
            </li>
            <li class="num">
              <input type="text" v-model="item.size" @blur="update(item,'size')" />
            </li>
            <li class="num">
              <input type="text" v-model="item.color" @blur="update(item,'color')" />
            </li>
            <li>{{item.price}}</li>
            <li class="options">
              <!-- <input type="text" v-model="item.options" /> -->
              <!-- 点击显示option -->
              <div @click="optionShow(index)">
                <p class="duoxuan">{{item.options}}</p>
              </div>
              <img src="../../../assets/img/triangle2.png" class="tubiao" alt />
              <!-- 选择option -->
              <div class="option" v-show="item.checked_2">
                <ul class="option-list">
                  <li v-for="(item1,index1) in  optionList[index]" :key="index1">
                    <input
                      type="checkbox"
                      v-model="item1.checked"
                      @change="optionsMoney(index,index1,item1,item)"
                      class="checkbox"
                    />
                    <span>{{item1.title}}</span>
                  </li>
                </ul>
              </div>
            </li>
            <li class="input">
              <input type="text" v-model="item.fba" @blur="update(item,'fba')" />
            </li>
            <li class="beikao">
              <img
                src="../../../assets/img/beikao2.png"
                alt
                @click="beikao(index)"
                style="margin:15px auto"
              />
              <div class="txt" v-show="item.checked_1">
                <textarea name id cols="28" rows="9" v-model="item.remark"></textarea>
                <div class="btn">
                  <a href="javascript:;" @click="lists[index].checked_1= false">閉じる</a>
                  <a
                    href="javascript:;"
                    style="color:#fff;background:#F3C622"
                    @click="remark(item,index)"
                  >提出</a>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 修改图片 -->
    <el-dialog title="修改图片" :visible.sync="editDialogVisible" width="30%">
      <div class="user-img">
        <img :src="pic" alt />
      </div>
      <el-upload
        class="upload-demo"
        ref="upload"
        action
        accept=".jpg, .jpeg, .png, .JPG, .JPEG"
        :auto-upload="false"
        :on-change="getFile"
      >
        <el-button
          style="margin-left: 10px;"
          size="small"
          type="success"
          @click="submitUpload"
        >上传到服务器</el-button>
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      </el-upload>
    </el-dialog>
    <!-- 添加商品 -->
    <el-dialog :visible.sync="addDialogVisible" width="80%">
      <div class="add">
        <h2>新規追加</h2>
        <ol>
          <li>管理番号</li>
          <li>URL</li>
          <li>サイズ</li>
          <li>カラー</li>
          <li>単価(元)</li>
          <li class="flex2">オプション</li>
          <li>FBA</li>
          <li>備考欄</li>
        </ol>
        <ul v-for="(item,index) in list.commodity" :key="index">
          <li>
            <input type="text" v-model="item.manageId" />
          </li>
          <li>
            <input type="text" v-model="item.url" />
          </li>
          <li>
            <input type="text" v-model="item.color" />
          </li>
          <li>
            <input type="text" v-model="item.size" />
          </li>
          <li>
            <input type="text" v-model="item.price" />
          </li>
          <li class="flex2">
            <p>{{item.options}}</p>
            <div class="options">
              <div class="li" v-for="(item1,index1) in optionList1[index]" :key="index1">
                <input type="checkbox" v-model="item1.checked" />
                <span>{{item1.title}}</span>
              </div>
              <!-- <ul>
                <li v-for="(item1,index1) in optionList" :key="index1">
                 
                </li>
              </ul>-->
            </div>
          </li>
          <li>
            <input type="text" v-model="item.fba" />
          </li>
          <li>
            <input type="text" v-model="item.remark" />
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getCommodityList,
  updateColumn,
  deleteCommodity
} from "../../../api/API/merchandise";
export default {
  data() {
    return {
      val: "",
      checked: "", // 全选
      token: localStorage.getItem("token"),
      lists: [],
      optionList: [],
      total: 0,
      optionsArr: [],
      optionList1: [
        [
          {
            checked: false,
            title: "①FBA(1元/点)"
          },
          {
            checked: false,
            title: "②有料検品(商品代金6%)"
          },
          {
            checked: false,
            title: "③OPP袋取り替え(0.5/点)"
          },
          {
            checked: false,
            title: "④織ネーム(2元/点)"
          },
          {
            checked: false,
            title: "⑤下げ札(1元/点)"
          },
          {
            checked: false,
            title: "⑥セット組(0.5元/組)"
          },
          {
            checked: false,
            title: "⑦印刷物封入(１元/面）"
          },
          {
            checked: false,
            title: "⑧印刷物封入( 2 元/両面）"
          },
          {
            checked: false,
            title: "⑨緩衝材梱包（１元/点）"
          },
          {
            checked: false,
            title: "⑩写真"
          }
        ]
      ],
      delArrId: [],
      editDialogVisible: false,
      addDialogVisible: false,
      pic: "",
      id: "",
      list: {
        commodity: [
          {
            manageId: "",
            pic: "",
            url: "",
            color: "",
            size: "",
            price: "",
            poptions: "",
            fba: "",
            title: false,
            remark: "",
            iid: "",
            type: "",
            company: ""
          }
        ]
      }
    };
  },
  created() {
    this.getCommodityList();
  },

  methods: {
    // 转换base 64位
    getBase64(file) {
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function() {
          imgResult = reader.result;
        };
        reader.onerror = function(error) {
          reject(error);
        };
        reader.onloadend = function() {
          resolve(imgResult);
        };
      });
    },
    getCommodityList() {
      let list = {
        mod: "inc",
        act: "ordersys",
        str: "getCommodityList",
        token: this.token
      };
      getCommodityList(list).then(res => {
        if (res.code != 1) return;
        this.lists = res.data;
        this.total = res.data.length;
        this.options();
        this.optionChecked();
        console.log(res);
      });
    },
    // 创建option
    options() {
      this.lists.forEach((item, index) => {
        if (item.options != null) {
          this.optionsArr[index] = item.options.split(",");
          this.optionsArr[index].unshift();
        } else {
          this.optionsArr[index] = item.options;
        }
        this.optionList[index] = [
          {
            checked: false,
            title: "①FBA(1元/点)"
          },
          {
            checked: false,
            title: "②有料検品(商品代金6%)"
          },
          {
            checked: false,
            title: "③OPP袋取り替え(0.5/点)"
          },
          {
            checked: false,
            title: "④織ネーム(2元/点)"
          },
          {
            checked: false,
            title: "⑤下げ札(1元/点)"
          },
          {
            checked: false,
            title: "⑥セット組(0.5元/組)"
          },
          {
            checked: false,
            title: "⑦印刷物封入(１元/面）"
          },
          {
            checked: false,
            title: "⑧印刷物封入( 2 元/両面）"
          },
          {
            checked: false,
            title: "⑨緩衝材梱包（１元/点）"
          },
          {
            checked: false,
            title: "⑩写真"
          }
        ];
      });
    },
    // 显示option
    optionShow(i) {
      if (this.lists[i].checked_2 == false) {
        this.lists.forEach((item, index) => {
          item.checked_2 = false;
        });
      }

      this.lists[i].checked_2 = !this.lists[i].checked_2;
      if (this.lists[i].checked_2 == false) {
        this.update(this.lists[i], "poptions");
      }
    },
    // options 选中
    optionsMoney(index, index1, item1, item) {
      this.lists[index].options = "";
      this.optionList[index][index1].checked = item1.checked;
      this.optionList[index].forEach((item, i) => {
        if (item.checked == true) {
          this.lists[index].options +=
            this.optionList[index][i].title.substr(0, 1) + ",";
        }
      });
    },
    // options 查看是否选中
    optionChecked() {
      this.optionsArr.forEach((item, index) => {
        if (item != null) {
          item.forEach((item1, index1) => {
            if (
              item1.substr(0, 1) ==
              this.optionList[index][index1].title.substr(0, 1)
            ) {
              this.optionList[index][index1].checked = true;
            }
          });
        }
      });
    },
    // 备注提示
    beikao(index) {
      this.lists.forEach(item => {
        item.checked_1 = false;
      });
      this.lists[index].checked_1 = true;
    },
    // 备注
    remark(item, index) {
      let list = {
        id: item.id,
        updateColumn: "remark",
        updateValue: item.remark
      };
      updateColumn(this.token, list).then(res => {
        console.log(res);
        if (res.code != 1) return this.$message.error(res.msg);
        this.lists[index].checked_1 = false;
        this.$message.success(res.msg);
      });
    },
    // 修改 : manageId, pic, color, size, poptions, fba,
    update(item, data) {
      var list = {
        id: item.id,
        updateColumn: data,
        updateValue: ""
      };
      if (data == "manageId") {
        list.updateValue = item.manageId;
      } else if (data == "pic") {
        list.updateValue = item.pic;
      } else if (data == "color") {
        list.updateValue = item.color;
      } else if (data == "size") {
        list.updateValue = item.size;
      } else if (data == "poptions") {
        list.updateValue = item.options;
      } else if (data == "fba") {
        list.updateValue = item.fba;
      }
      updateColumn(this.token, list).then(res => {
        console.log(res);
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success(res.msg);
      });
    },
    // 全选
    allChecked() {
      this.delArrId = [];
      if (this.checked == true) {
        this.lists.forEach(item => {
          this.delArrId.push(item.id);
          item.checked = true;
        });
      } else {
        this.lists.forEach(item => {
          item.checked = false;
        });
        this.delArrId = [];
      }
    },
    // 选择
    checkedItem() {
      this.delArrId = [];
      this.lists.forEach(item => {
        if (item.checked == true) {
          this.delArrId.push(item.id);
        }
      });
      this.lists.every(item => item.checked == true) == true
        ? (this.checked = true)
        : (this.checked = false);
    },
    // 删除
    deleteCommodity() {
      if (this.delArrId == false) return this.$message.error("请选则删除项");
      deleteCommodity(this.token, { ids: this.delArrId.join(",") }).then(
        res => {
          if (res.code != 1) return this.$message.error(res.msg);
          this.$message.success(res.msg);
          this.getCommodityList();
        }
      );
    },
    getFile(file, fileList) {
      this.pic = URL.createObjectURL(file.raw);
      this.getBase64(file.raw).then(res => {
        this.imageBase = res;
      });
      console.log(this.pic);
    },
    // 更换头像
    submitUpload() {
      var list = {
        id: this.id,
        updateColumn: "pic",
        updateValue: this.pic
      };
      console.log(this.pic);

      updateColumn(this.token, list).then(res => {
        console.log(res);
        if (res.code != 1) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.editDialogVisible = false;
      });
    },
    edit(item) {
      this.id = item.id;
      this.pic = item.pic;
      this.editDialogVisible = true;
    },
    zhuwen() {
      console.log(123);

      this.$router.push({
        name: "zhuwen",
        query: { cid: this.delArrId.join(","), state: 1 }
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.main {
  width: 1208px;
  margin-bottom: 200px;
  //   height: 1000px;
  h2 {
    height: 40px;
    background-color: #eee;
    line-height: 40px;
    padding-left: 20px;
    font-size: 20px;
    span {
      color: #F3C622;
    }
  }
  .search {
    overflow: hidden;
    margin-top: 20px;
    a {
      color: #333;
      padding: 0 20px;
    }
    .fr {
      position: relative;
      margin-right: 30px;
      a {
        display: inline-block;
        height: 32px;
        line-height: 32px;
        color: #fff;
        background: #F3C622;
        margin-left: 15px;
        border-radius: 5px;
      }
    }
    input {
      width: 150px;
      height: 30px;
    }
  }
  .content {
    margin-top: 10px;

    p {
      text-align: right;
      padding-right: 30px;
      span {
        cursor: pointer;
      }
    }
    .all {
      //   overflow: hidden;
      .checked {
        input {
          width: 15px;
          height: 15px;
          vertical-align: middle;
        }
        strong {
          margin: 0 20px;
        }
        span {
          cursor: pointer;
        }
      }
    }
    .caozuo {
      //   overflow: hidden;
      margin-right: 30px;
      .a {
        display: inline-block;
        height: 35px;
        padding: 0 15px;
        line-height: 35px;
        color: #fff;
        background-color: #F3C622;
        margin: 10px 0 0 20px;
        border-radius: 5px;
      }
      .zhuijia {
        &:hover ul {
          display: block;
        }
        position: relative;
        ul {
          display: none;
          position: absolute;
          overflow: hidden;
          top: 35px;
          left: 0;
          width: 100px;
          height: 50px;
          border-radius: 5px;
          //   background: pink;
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
          li {
            margin: 0;
            height: 25px;
            line-height: 25px;
            a {
              width: 100px;
              display: block;
              text-align: center;
              background: #fff;
              color: #333;
              font-size: 14px;
            }
          }
        }
      }
    }
    .containet {
      margin-top: 80px;
      border: 1PX solid #ccc;
    }
    ol {
      height: 40px;
      background: #F3C622;
      color: #fff;
      display: flex;
      line-height: 40px;
    }
    .ul {
      height: 70px;
      line-height: 70px;
      display: flex;
      .checkbox {
        input {
          margin-top: 22px;
          width: 25px;
          height: 25px;
        }
      }
      .input {
        input {
          width: 100px;
          height: 25px;
        }
      }
      .img {
        width: 50px;
        height: 50px;
        margin: 10px auto;
        position: relative;
        &:hover .img-box {
          display: block;
        }
        &:hover .upload {
          display: block;
        }
        &:hover .yinying {
          display: block;
        }

        .yinying {
          position: absolute;
          top: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.3);
          width: 50px;
          height: 50px;
          display: none;
        }
        img {
          width: 50px;
          height: 50px;
        }
        .img-box {
          position: absolute;
          top: -100px;
          left: 80px;
          width: 300px;
          height: 400px;
          display: none;
          img {
            width: 300px;
            height: 400px;
          }
        }
        .upload {
          position: absolute;
          top: 0;
          right: 0;
          width: 20px;
          height: 20px;
          font-size: 20px;
          //   background: pink;
          color: #fff;
          cursor: pointer;
          display: none;
        }
      }
      .num {
        input {
          width: 80px;
          height: 25px;
        }
      }
      .beikao {
        position: relative;
        cursor: pointer;
        .txt {
          position: absolute;
          top: 20px;
          right: 0;
          width: 220px;
          height: 190px;
          background: #eee;
          z-index: 1;
          border: 1PX solid #ccc;
          textarea {
            margin-top: 4px;
          }
          .btn {
            margin-top: 5px;
            a {
              float: right;
              height: 25px;
              margin-right: 5px;
              padding: 0 10px;
              line-height: 25px;
              border: 1PX solid #F3C622;
              font-size: 12px;
              color: #F3C622;
              border-radius: 5px;
            }
          }
        }
        img {
          width: 30px;
          height: 30px;
          margin-left: 20px;
        }
      }
    }
    li {
      flex: 1;
      float: left;
      text-align: center;
    }
    .options {
      position: relative;
      display: block;
      flex: 2;
      .duoxuan {
        position: relative;
        margin-top: 22px;
        border: 1PX solid #ccc;
        width: 200px;
        height: 27px;
        line-height: 27px;
        text-align: left;
        cursor: pointer;
      }

      .tubiao {
        position: absolute;
        top: 35px;
        right: 10px;
      }

      .option {
        position: absolute;
        top: 45px;
        left: 0px;
        background-color: #fff;
        width: 230px;
        height: 200px;
        border: 1PX solid #ccc;
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 99;

        .option-list {
          width: 230px;
          height: 200px;

          li {
            margin-left: 0;
            padding-left: 5px;
            text-align: left;
            height: 30px;
            float: none !important;
            width: 225px !important;
            margin-bottom: 3px;
            line-height: 30px;
            position: relative;
            font-size: 12px;

            .checkbox {
              position: absolute;
              top: 10px;
              left: 5px;
              width: 12px;
              height: 12px;
            }

            span {
              margin: 0 5px 0 15px;
            }

            .choose {
              background: #eee;
            }
          }
        }
      }
    }
  }
}
.user-img {
  width: 300px;
  height: 300px;
  margin: 0 auto 20px;

  img {
    width: 100%;
    height: 100%;
  }
}
.add {
  height: 600px;
  overflow: auto;
  h2 {
    height: 60px;
    background: #F3C622;
    color: #fff;
    font-size: 20px;
    padding-left: 20px;
    line-height: 60px;
  }
  ol {
    display: flex;
    height: 40px;
    line-height: 40px;
    background: #eee;
    font-size: 16px;
  }
  ul {
    height: 50px;
    display: flex;
    line-height: 50px;
    li {
      float: left;
    }
  }
  li {
    float: left;
    text-align: center;
    flex: 1;
    input {
      width: 100px;
      height: 30px;
      font-size: 16px;
    }
    p {
      width: 200px;
      height: 30px;
      margin: 10px auto;
      border: 1PX solid #ccc;
      position: relative;
    }
  }
  .flex2 {
    position: relative;
    flex: 2;
    .options {
      position: absolute;
      top: 41PX;
      left: 50%;
      transform: translate(-50%, 0);
      border: 1PX solid #ccc;
      width: 200px;
      height: 150px;
      overflow: auto;
      .li {
        text-align: left;
        height: 20px;
        line-height: 20px;
        font-size: 12px;

        input {
          width: 15px;
          height: 15px;
          vertical-align: middle;
          margin: 0 5px;
        }
      }
    }
  }
}
</style>